import { render } from "./GuestDetails.vue?vue&type=template&id=993e9090&ts=true"
import script from "./GuestDetails.vue?vue&type=script&lang=ts"
export * from "./GuestDetails.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/mmwapp/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__